import { useParams } from 'react-router-dom';
import { generateApiPath } from 'src/utils';
import ModalDialog, { ModalCloseHandler } from 'src/components/ModalDialog';
import { SortOrder } from 'src/components/DataTable/types';
import { useForm, FormField } from 'src/components/Form';
import {
  pepApiRequest,
  ContentType,
  RequestMethod,
  useStatefulApi,
} from 'src/services';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore, { useSolutionDetails } from '../../redux';
import { uploadFormFields, uploadModelFormFields } from '../formFields';
import { API_POST_ASSET_CONFIG_UPLOAD, API_POST_ASSET_MODEL_CONFIG_UPLOAD } from '../../constants';

const formStyle = {
  flexDirection: 'row',
  '.MuiFormControl-root': {
    width: ({ spacing }) => spacing(90),
  },
};

type Props = {
  api: string;
  formFields: FormField[];
  title: string;
  open: boolean;
  onClose: ModalCloseHandler;
  sitesId?: string;
  id?: string;
  pageIndex?: number;
  pageSize?: number;
  sortOrder?: SortOrder;
};

function SolutionAssetUploadModal({
  id,
  open,
  onClose,
}: Props) {
  const actions = useStoreUnitActions(solutionsStore);
  const { showAlert } = useAlert();
  const { solutionId } = useParams();
  const [solutionDetails] = useSolutionDetails();

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generateApiPath(API_POST_ASSET_MODEL_CONFIG_UPLOAD, {
          solutionId,
          twinId: id,
        }),
        useProxy: false,
        contentType: ContentType.FormData,
        params,
      }),
    (res, params) => {
      showAlert({
        type: AlertType.Success,
        title: 'Asset model file uploaded',
        text: `Asset model file ${params.file.path} is uploaded successfully.`,
      });
      onClose();
      actions.assetModelData({ solutionId, twinId: id });
    },
    (err) => {
      if (typeof err === 'object' && err?.status === 400) {
        return;
      }
      console.log('Error while uploading asset model file:', err);
      showAlert({
        type: AlertType.Error,
        title: 'Asset model file not uploaded',
        text: 'Error while uploading file.',
      });
    }
  );
  const [formComponent, handleSubmit] = useForm({
    sx: formStyle,
    fields: uploadModelFormFields,
    onSubmit,
  });

  return (
    <ModalDialog
      title="Upload configuration"
      open={open}
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Save"
      maxWidth="lg"
    >
      {formComponent}
    </ModalDialog>
  );
}

export default SolutionAssetUploadModal;
